import * as CONSTRUCTOR from '../../generate';

export const tokenSettingsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'TokenSettings',
  fragmentName: 'TokenSettingsResponseFields',
  fields: `{
    id
    project_id
    price_minor
    currency_code
    validity_duration_days
    limit_per_opportunity
    created_at
    updated_at
  }`,
});
